import type { ApplicantHistoryEvent } from '../types'

export const getEventChronoDate = (event: ApplicantHistoryEvent) => {
  let eventDate = event.created
  if (event.scheduledDate && event.type !== 'availability_update') {
    eventDate = event.scheduledDate
  }
  if (event.completionDate) {
    eventDate = event.completionDate
  }
  return eventDate
}
